import {
  CuratedColumnSymbology,
  InterpolationTypes,
  SymbologyScales,
  SymbologyTypes,
} from 'uf/symbology';

const symbologies: Record<string, Record<string, CuratedColumnSymbology[]>> = {
  '/public/dataset/hifld_us_colleges': {
    naics_desc: [
      {
        display_hints: {
          distribution: null,
          interpolation: InterpolationTypes.CATEGORICAL,
          is_reverse_theme: true,
          scale: SymbologyScales.CATEGORICAL,
          theme: 'custom',
        },
        paint: {
          'circle-color': {
            default: '#7f7f7f',
            property: 'naics_desc',
            stops: [
              {
                color: '#ab149e',
                value: 'BUSINESS AND SECRETARIAL SCHOOLS',
              },
              {
                color: '#653294',
                value: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
              },
              {
                color: '#9f0500',
                value: 'COSMETOLOGY AND BARBER SCHOOLS',
              },
              {
                color: '#d62728',
                value: 'EDUCATIONAL SUPPORT SERVICES',
              },
              {
                color: '#e27300',
                value: 'FINE ARTS SCHOOLS',
              },
              {
                color: '#b0bc00',
                value: 'JUNIOR COLLEGES',
              },
              {
                color: '#fcc400',
                value: 'OTHER TECHNICAL AND TRADE SCHOOLS',
              },
            ],
            type: 'categorical',
          },
          'circle-opacity': 0.7,
          'circle-stroke-color': 'transparent',
        },
        type: SymbologyTypes.CIRCLE,
      },
    ],
  },
};

export default symbologies;
